module.exports = __webpack_public_path__ + "img/blueTick.b65891dd.svg";